import React from 'react'

const FilterList = ({ windowHeight, headerHeight, isTablet, children }) => {
  const modifier = isTablet ? 195 : 240
  const maxHeight = windowHeight - (headerHeight + modifier)
  if (!maxHeight) return null

  return (
    <div className='relative mt2 pa2 ba b--black'>
      <div
        component='div'
        className='o-auto'
        style={{ maxHeight }}
      >
        {children}
      </div>
    </div>
  )
}

export default FilterList
